<section class="message" [formGroup]="form" *ngIf="form">
  <div class="message__body" *ngIf="assignShipmentActionControl?.value!== AssignShipmentAction.Assign">
    <app-row align="center" gutter="x-sm">
      <app-col cols="auto">
        <app-avatar
          class="align-middle"
          size="32"
          radius="16"
          bgColor="var(--color-accent-light)"
          fgColor="var(--color-accent)"
          iconType="svg"
          icon="bold-warning"
        ></app-avatar>
      </app-col>

      <app-col *ngIf="assignShipmentActionControl.value===AssignShipmentAction.Override">
        <h5 class="text-warn m-0 p-0">{{"sharedFeatures.ShipmentAssignment.OverrideDetected"| translate}}!</h5>
        <p class="message__content">
          <ng-container *ngIf="truckRunningShipment && driverRunningShipment;else viewOneShipmentDetails">
            <div *ngIf="driverRunningShipment">
              <span>{{ ("sharedFeatures.ShipmentAssignment.TheDriver" | translate) | titlecase }}</span>
              <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
              <a
                class="text-underline text-warn"
                [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: driverRunningShipment?.id, type: ShipmentsListType.All })"
                target="_blank"
              >
                <span class="weight-semibold">{{ driverRunningShipment?.id || "___" }}</span>
              </a>
              <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>

              <span class="weight-semibold">{{ driverRunningShipment?.pickUpLocation?.city?.name || "___" }}</span>
              {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
              <span class="weight-semibold">{{ driverRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
            </div>
            <br />
            <div *ngIf="truckRunningShipment">
              <span>{{ ("sharedFeatures.ShipmentAssignment.TheTruck" | translate) |titlecase}}</span>
              <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
              <a
                class="text-underline text-warn"
                [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: truckRunningShipment?.id, type: ShipmentsListType.All })"
                target="_blank"
              >
                <span class="weight-semibold">{{ truckRunningShipment?.id || "___" }}</span>
              </a>
              <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>

              <span class="weight-semibold">{{ truckRunningShipment?.pickUpLocation?.city?.name || "___" }}</span>
              {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
              <span class="weight-semibold">{{ truckRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
            </div>
            <br />
            {{ "sharedFeatures.ShipmentAssignment.CloseShipment" | translate }} {{ (("sharedFeatures.ShipmentAssignment.ThoseShipments" | translate) |
            lowercase) | lowercase }}
          </ng-container>
          <ng-template #viewOneShipmentDetails>
            <span>{{"sharedFeatures.ShipmentAssignment.Kindly"| translate }}</span>
            <span>
              {{ (driverRunningShipment? "sharedFeatures.ShipmentAssignment.TheDriver" :"sharedFeatures.ShipmentAssignment.TheTruck" )| translate }}
            </span>
            <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
            <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>

            <span class="weight-semibold">
              {{ driverRunningShipment? driverRunningShipment?.pickUpLocation?.city?.name : truckRunningShipment?.pickUpLocation?.city?.name || "___"
              }}
            </span>
            {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
            <span class="weight-semibold">
              {{ driverRunningShipment? driverRunningShipment?.dropOffLocation?.city?.name : truckRunningShipment?.dropOffLocation?.city?.name|| "___"
              }}
            </span>
            {{ "sharedFeatures.ShipmentAssignment.CloseShipment" | translate }} {{ ("sharedFeatures.ShipmentAssignment.ThisShipment" | translate) |
            lowercase }}

            <a
              class="text-underline text-warn"
              [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold">{{ driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id || "___" }}</span>
            </a>
          </ng-template>
          ?
        </p>
      </app-col>
      <app-col *ngIf="assignShipmentActionControl.value === AssignShipmentAction.AssignAndAutoStart">
        <h5 class="text-warn m-0 p-0">{{"sharedFeatures.ShipmentAssignment.Hint"| translate}}!</h5>
        <p class="message__content">
          <ng-container *ngIf="truckRunningShipment && driverRunningShipment;else viewOneShipmentDetails">
            <div *ngIf="driverRunningShipment">
              <span>{{"sharedFeatures.ShipmentAssignment.TheDriver" | translate | titlecase }}</span>
              <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
              <a
                class="text-underline text-warn"
                [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: driverRunningShipment?.id, type: ShipmentsListType.All })"
                target="_blank"
              >
                <span class="weight-semibold">{{ driverRunningShipment?.id || "___" }}</span>
              </a>
              <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>

              <span class="weight-semibold">{{ driverRunningShipment?.pickUpLocation?.city?.name|| "___" }}</span>
              {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
              <span class="weight-semibold">{{ driverRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
              .
            </div>
            <br />
            <div *ngIf="truckRunningShipment">
              <span>{{"sharedFeatures.ShipmentAssignment.TheTruck" | translate | titlecase }}</span>
              <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
              <a
                class="text-underline text-warn"
                [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: truckRunningShipment?.id, type: ShipmentsListType.All })"
                target="_blank"
              >
                <span class="weight-semibold">{{ driverRunningShipment?.id || "___" }}</span>
              </a>
              <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>

              <span class="weight-semibold">{{ truckRunningShipment?.pickUpLocation?.city?.name|| "___" }}</span>
              {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
              <span class="weight-semibold">{{ truckRunningShipment?.dropOffLocation?.city?.name || "___" }}</span>
              .
            </div>

            <br />
            {{ "sharedFeatures.ShipmentAssignment.ThisShipment" | translate }}
            <a
              *ngIf="shipmentId"
              class="text-underline text-warn"
              [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: shipmentId, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold">{{ shipmentId || "___" }}</span>
            </a>
            {{ "sharedFeatures.ShipmentAssignment.WillStart" | translate }} {{ ("sharedFeatures.ShipmentAssignment.ThoseShipments" | translate) |
            lowercase}} {{"sharedFeatures.ShipmentAssignment.Are" | translate}}
          </ng-container>

          <ng-template #viewOneShipmentDetails>
            <span>{{"sharedFeatures.ShipmentAssignment.Kindly"| translate }}</span>
            <span>
              {{ (driverRunningShipment? "sharedFeatures.ShipmentAssignment.TheDriver" :"sharedFeatures.ShipmentAssignment.TheTruck" )| translate }}
            </span>
            <span>{{"sharedFeatures.ShipmentAssignment.HasRunningShipment" | translate }}</span>
            <span>{{"sharedFeatures.ShipmentAssignment.From" | translate }}</span>

            <span class="weight-semibold">
              {{ ( driverRunningShipment? driverRunningShipment?.pickUpLocation?.city?.name : truckRunningShipment?.pickUpLocation?.city?.name)||
              "___" }}
            </span>
            {{ "sharedFeatures.ShipmentAssignment.To"| translate}}
            <span class="weight-semibold">
              {{(driverRunningShipment? driverRunningShipment?.dropOffLocation?.city?.name : truckRunningShipment?.dropOffLocation?.city?.name)||
              "___" }}
            </span>
            .
            <br />
            {{ "sharedFeatures.ShipmentAssignment.ThisShipment" | translate }}
            <a
              *ngIf="shipmentId"
              class="text-underline text-warn"
              [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: shipmentId, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold">{{ shipmentId || "___" }}</span>
            </a>
            {{ "sharedFeatures.ShipmentAssignment.WillStart" | translate }}
            <a
              class="text-underline text-warn"
              [routerLink]="RoutesUtil.ShipmentsViewWithoutRange.url({ id: driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id, type: ShipmentsListType.All })"
              target="_blank"
            >
              <span class="weight-semibold">{{( driverRunningShipment? driverRunningShipment?.id:truckRunningShipment?.id) || "___" }}</span>
            </a>
            {{"sharedFeatures.ShipmentAssignment.Is" | translate}}
          </ng-template>
          {{ "sharedFeatures.ShipmentAssignment.SuccessfullyDelivered" | translate }}
        </p>
      </app-col>
    </app-row>
  </div>
  <div class="message__action" *ngIf="isViewActions">
    <div actions>
      <mat-radio-group formControlName="assignShipmentAction">
        <mat-radio-button [value]="AssignShipmentAction.Override" class="d-block">
          {{ "sharedFeatures.ShipmentAssignment.ConfirmOverride"| translate}}
        </mat-radio-button>
        <mat-radio-button [value]="AssignShipmentAction.Assign" class="d-block">
          {{ "sharedFeatures.ShipmentAssignment.JustAssign"| translate}}
        </mat-radio-button>
        <mat-radio-button [value]="AssignShipmentAction.AssignAndAutoStart" class="d-block">
          {{ "sharedFeatures.ShipmentAssignment.AssignAndAutoStart"| translate}}
        </mat-radio-button>
      </mat-radio-group>
      <div *ngIf="assignShipmentActionControl.value === AssignShipmentAction.Override" class="text-area">
        <mat-label class="asterisk-after">{{ "sharedFeatures.ShipmentAssignment.Justification"| translate}}</mat-label>
        <mat-form-field appearance="outline">
          <textarea type="text" matInput formControlName="justification"></textarea>
          <mat-error *ngIf="justificationControl.touched && justificationControl.errors?.required">
            {{ "sharedFeatures.ShipmentAssignment.ErrorMessageRequired" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</section>
